import { render, staticRenderFns } from "./MainExam.vue?vue&type=template&id=777e0f7a"
import script from "./MainExam.vue?vue&type=script&lang=js"
export * from "./MainExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports